<template>
    <content-view v-show="$utils.renderWhen(this,'groupPhoto')">
        <div class="stored-photo-group">
            <div class="mt24 mb24 pt24 pl24 pb24 pr24">
                <template v-if="!showBatch">
                    <span class="font-biggest mr32">{{albumId == -1 ? '未分组' : dataDetail.name}}</span>
                    <a-button type="primary" @click="$refs.addPhoto.open($route.params.id)">上传图片</a-button>
                    <a-button type="primary" @click="showBatch = true">批量管理</a-button>
                    <a-button type="primary" @click="$refs.addAlbum.open(dataDetail)" v-if="albumId != -1">编辑相册</a-button>
                    <div class="mb16 mt16">{{dataDetail.displayName}}</div>
                    <div>{{dataDetail.description}}</div>
                </template>
                <template v-else>
                    <a-button type="primary" @click="showConfirm(idList)">删除</a-button>
                    <a-button type="primary" @click="openMove(idList)">移动到相册</a-button>
                    <span>（拖拽图片可调整排序）</span>
                    <a class="text-primary float-right mt8" @click="batchOk">完成管理</a>
                </template>
            </div>
            <draggable
                class="syllable_ul"
                element="section"
                :list="list"
                :options="{group:'title', animation:150}"
                :no-transition-on-drag="true"
                :forceFallback="true"
                :disabled="!showBatch"
                @end="changeEnd"
            >
                <transition-group class="stored-photo-group-list">
                    <div v-for="(item,index) in list" :key="item.id" class="item-photo">
                        <span v-if="index == 0 && !showBatch" class="item-sheshi">封面<span></span></span>
                        <img
                        :preview="!showBatch"
                        alt="暂无图片"
                        :src="item.url"
                        @click="onChecked(item.id)"
                        />
                        <div class="name" :title="item.displayName">{{item.displayName}}</div>
                        <a-checkbox @click="onChecked(item.id)" :checked="item.checked" v-if="showBatch" class="item-checkbox"></a-checkbox>
                        <div v-else class="item-op">
                            <span class="item-tip">
                                <a-icon type="down" />
                            </span>
                            <div class="item-op-list">
                                <div @click="openMove([item.id])"><a-icon type="edit" /> 移动分组</div>
                                <div @click="showConfirm([item.id])"><a-icon type="delete" /> 删除</div>
                            </div>
                        </div>
                    </div>
                </transition-group>
            </draggable>
            <div v-if="list.length == 0"  class="stored-photo-group-list flex">
                <a-empty />
            </div>
            <a-modal title="选择相册" v-model="shopMoveModal" @ok="batchMove" @cancel="cancelMove" centered>
                <a-tag @click="onChangeChceked(item.id)" class="group-tag" v-for="item in groupList" :key="item.id" :color="item.checked ? 'orange' : ''">{{item.name}}</a-tag>
            </a-modal>
            <add-album ref="addAlbum" @cancel="getList"></add-album>
            <add-photo ref="addPhoto" @cancel="getList" :list="groupList"></add-photo>
        </div>
    </content-view>
</template>
<script>
    import ImagesUploader from '@/components/common/images-uploader.component';
    import addAlbum from '@/components/modules/stored-photo/add-album.component';
    import addPhoto from '@/components/modules/stored-photo/add-photo.component';
    import draggable from 'vuedraggable';

export default {
    name: 'storedPhoto',
    components: {
        ImagesUploader,
        addAlbum,
        addPhoto,
        draggable
    },
    data() {
        return {
            form: this.$form.createForm(this),
            list: [],
            shopMoveModal: false,
            groupList: [],
            showAddAlbum: false,
            dataDetail: {},
            showBatch: false,
            albumId: this.$route.query.id,
            idList: []
        }
    },
    methods: {
        getDeetail() {
            this.$api.storedPhoto.getAlbumDetail({
                params: {
                    id: this.albumId
                }
            }).then(res => {
                this.dataDetail = res;
            });
        },
        getList() {
            this.albumId != -1 && this.getDeetail();
            this.$api.storedPhoto.getResource({
                query: {
                    shopId: this.$route.params.id,
                    albumId: this.albumId
                }
            }).then(res => {
                res.map(item => item.checked = false)
                this.list = res;
            });
        },
        showConfirm(idList) {
            if(idList.length == 0) {
                this.$message.warning('请先选择图片')
                return
            }
            let _this = this;
            this.$confirm({
                title: '是否确认删除图片？',
                centered: true,
                onOk() {
                    _this.$api.storedPhoto.batchDeleteResource({
                        body: {
                            idList: idList,
                        }
                    }).then(res => {
                        _this.idList = [];
                        _this.$message.success('操作成功');
                        _this.getList();
                    });
                },
                onCancel() {},
            });
        },
        getGroupList() {
            this.$api.storedPhoto.getAlbum({
                query: {
                    shopId: this.$route.params.id,
                }
            }).then(res => {
                res.map(item => {
                    item.checked = item.id == this.albumId;
                    return item
                })
                this.groupList = res;
            });
        },
        openMove(idList) {
            if(idList.length == 0) {
                this.$message.warning('请先选择图片')
                return
            }
            this.idList = idList;
            this.shopMoveModal = true;
        },
        onChangeChceked(id) {
            this.groupList.map(item => {
                item.checked = item.id == id;
                return item
            })
        },
        batchMove() {
            this.$api.storedPhoto.batchUpdateResource({
                body: {
                    albumId: this.groupList.filter(item => item.checked)[0].id,
                    shopId: this.$route.params.id,
                    idList: this.idList
                }
            }).then(res => {
                this.idList = [];
                this.$message.success('操作成功');
                this.getList();
                this.cancelMove();
            });
        },
        cancelMove() {
            this.shopMoveModal = false;
            this.groupList.map(item => {
                item.checked = item.id == this.albumId
                return item    
            });
            this.form.resetFields();
        },
        changeEnd(e) {
            let idList = [];
            this.list.forEach(item => {
                idList.push(item.id)
            })
            this.$api.storedPhoto.batchOrderResource({
                body: {
                    idList: idList
                }
            }).then(res => {
                this.$message.success('操作成功');
                this.getList();
            });
        },
        onChecked(id) {
            if(!this.showBatch) return
            this.idList = [];
            this.list.forEach(item => {
                if(item.id == id) {
                    item.checked = !item.checked;
                }
                if(item.checked) {
                    this.idList.push(item.id)
                }
            })
        },
        batchOk() {
            this.showBatch = false;
            this.list.map(item => item.checked = false)
        }
    },
    mounted() {
        this.getList()
        this.getGroupList()
    }
}
</script>
<style scoped lang="scss">
.stored-photo-group {
    >div {
        background-color: #fff;
    }
    .ant-alert {
        margin-right: 24px;
    }
    &-list {
        display: flex;
        flex-wrap: wrap;
        padding: 24px 0 24px 24px;
        background-color: #fff;
        .item-sheshi {
            position: absolute;
            left: -1px;
            top: -1px;
            z-index: 10;
            width: 36px;
            height: 25px;
            padding: 4px 4px 0;
            text-align: center;
            font-size: 14px;
            white-space: nowrap;
            color: #FFF;
            cursor: pointer;
            background-color: #fdcd52;
            >span {
                position: absolute;
                z-index: -1;
                top: 20px;
                left: 0;
                border-width: 8px 18px;
                border-style: solid solid dashed solid;
                border-color: #fdcd52;
                border-bottom-color: transparent;
            }
        }
        .item-photo {
            margin-right: 24px;
            margin-bottom: 24px;
            position: relative;
            >img {
                width: 170px;
                height: 142px;
                cursor: pointer;
                border: 1px solid #f5f5f5
            }
            .name {
                width: 170px;
                text-overflow : ellipsis;
                white-space: nowrap;
                overflow: hidden;
                height: 40px;
                line-height: 40px;
                padding-left: 8px;
                background-color: #f6f6f6;
            }
            .item-op {
                position: absolute;
                right: 10px;
                top: 10px;
                display: none;
                .item-tip {
                    position: relative;
                    padding: 0 2px;
                    width: 20px;
                    height: 20px;
                    *zoom: 1;
                    background: #fff;
                    border-radius: 3px;
                    cursor: pointer;
                    border: 1px solid #D6D6D6;
                }
                .item-op-list {
                    display: none;
                    position: absolute;
                    top: 19px;
                    right: 0;
                    padding-left: 8px;
                    width: 100px;
                    background: #fff;
                    border-radius: 4px 0 4px 4px;
                    border: 1px solid #D6D6D6;
                    >div {
                        margin: 8px;
                        cursor: pointer;
                    }
                }
                &:hover {
                    .item-tip {
                        z-index: 10;
                        border-bottom-color: #fff;
                    }
                    .item-op-list {
                        display: block;
                    }
                }
            }
            &:hover .item-op {
                display: block;
            }
            .item-checkbox {
                position: absolute;
                left: 3px;
                top: 0;
            }
        }
    }
}
.group-tag {
    cursor: pointer;
}
</style>